/**
 * A class to handle the mobile menu.
 */
class MenuHandler {
	constructor() {
		// Assign variables
		this.body = document.body;
		this.hamburgerButton = document.getElementById('hamburger')
		this.mainNav = document.getElementById('nav-main')
		this.menuItemsWithSubMenu = document.querySelectorAll('.nav-main .menu-item-has-children > a')
		this.homeButton = document.querySelector('.nav-main__list > li:first-of-type')

		this.closeUspBarPanel = document.querySelectorAll('.header-usp-bar__panel__close');
        this.uspBar = document.querySelector('.header-usp-bar');
        this.uspBarPanels = Array.from(document.querySelectorAll('.header-usp-bar__panel'));
        this.uspBarTexts = document.querySelectorAll('.header-usp-bar__left ul li');
        this.uspBarLeft = document.querySelector('.header-usp-bar__left ul');
		this.uspBarPanelToggle = document.querySelector('.usp-bar-panel-toggle')

        this.animationPaused = false;
		this.mainNavUl = document.getElementById('nav-main-list')
		this.isPortraitVisible = true
		this.headerNew = document.querySelector('.header-new')
		this.logoBoxParent = document.querySelector('.header-new__top__mid')
		this.logoBox = document.querySelector('.logo-box')
		this.portret = document.querySelector('.logo-box .portret')
		this.logo = document.querySelector('.logo-box .logo')
		this.flyOutContainer = document.querySelector('.fly-out__container')
		this.siteHeader = document.querySelector('.header-new__top')

		// Bind functions
		this.handleHamburgerButtonClick = this.handleHamburgerButtonClick.bind(this)
		this.maybeCloseMenu = this.maybeCloseMenu.bind(this)
		this.closeMenu = this.closeMenu.bind(this)
		this.handleSubMenuClick = this.handleSubMenuClick.bind(this)
		this.maybeAddBackButton = this.maybeAddBackButton.bind(this)
		this.stickFlyoutToHeaderTop = this.stickFlyoutToHeaderTop.bind(this)
		this.handleWindowResize = this.handleWindowResize.bind(this)
		this.handleMainNavClick = this.handleMainNavClick.bind(this)
		this.maybeSubMenuGoBack = this.maybeSubMenuGoBack.bind(this)

		// Stick flyout to header top
		this.stickFlyoutToHeaderTop()

		// Add event listeners
		this.addEventListeners()

		// Observe the USP bar
		if(!document.body.classList.contains('single-product')) {
			this.uspBarObserver.observe(this.uspBar)
		}
	}

	addEventListeners() {
		// Add event listeners for hamburger button and main navigation
		this.hamburgerButton.addEventListener('click', this.handleHamburgerButtonClick);
		this.mainNav.addEventListener('click', this.handleMainNavClick);
	
		// Adding event listeners for uspBarTexts (links in the left bar)
		if (this.uspBarTexts.length > 0) {
			this.uspBarTexts.forEach(uspBarText => {
				let link = uspBarText.querySelector('a');

				if(!link) {
					return
				}
				
				// Extract the URL part after the hash (#) symbol
				let isHashLink = link.href.endsWith('#') || link.href === '#';
		
				// Check if the link is a hash or empty link
				if (isHashLink) {
					link.addEventListener('click', (e) => {
						e.preventDefault();
						
						let clickedIndex = parseInt(uspBarText.getAttribute('data-index'), 10);
						
						if (clickedIndex >= 0 && clickedIndex < this.uspBarPanels.length) {
							let targetPanel = this.uspBarPanels[clickedIndex];
							
							// Toggle 'active' class on the clicked panel
							if (targetPanel.classList.contains('active')) {
								targetPanel.classList.remove('active');
							} else {
								// Remove 'active' class from all panels
								this.uspBarPanels.forEach(uspBarPanel => {
									uspBarPanel.classList.remove('active');
								});
								targetPanel.classList.add('active');
							}
	
							// Call toggleAnimation if it exists
							if (typeof this.toggleAnimation === 'function') {
								if (this.uspBarPanels.length > 1 && !this.uspBarLeft.classList.contains('animation-paused')) {
									this.toggleAnimation();
								}
							}
						}
					});
				}
			});
		}
	
		// Adding event listeners for close buttons in uspBarPanels
		this.closeUspBarPanel.forEach(closeUspBarPanel => {
			closeUspBarPanel.addEventListener('click', (e) => {
				e.preventDefault();
				this.uspBarPanels.forEach(uspBarPanel => {
					uspBarPanel.classList.remove('active');
				});
	
				if (this.uspBarPanels.length > 1) {
					this.toggleAnimation();
				}
			});
		});
	
		// If clicked outside the uspBarPanel, close the panel
		document.body.addEventListener('click', (e) => {
			const isClickInsideUspBarPanel = this.uspBarPanels.some(uspBarPanel => uspBarPanel.contains(e.target));
			const isClickInsideUspBar = this.uspBar.contains(e.target);
			
			if (!isClickInsideUspBarPanel && !isClickInsideUspBar) {
				this.uspBarPanels.forEach(uspBarPanel => {
					uspBarPanel.classList.remove('active');
				});
	
				this.toggleAnimation();
			}
		});
	
		// Set or remove event listeners or classes based on window width
		this.handleWindowResize();
		// Add event listener for window resizing
		window.addEventListener('resize', this.handleWindowResize);
	}
	
	toggleAnimation() {
		this.animationPaused = !this.animationPaused; // Toggle animation state

		if(!this.uspBarLeft) {
			return
		}
	
		if (this.animationPaused) {
			this.uspBarLeft.classList.add('animation-paused'); // Add class to pause animation
		} else {
			this.uspBarLeft.classList.remove('animation-paused'); // Remove class to resume animation
		}
	}

	// Stick flyout to header top
	stickFlyoutToHeaderTop() {
		let siteHeaderBottom = this.siteHeader.getBoundingClientRect().bottom

		// Update the inline CSS height of the flyOutContainer
		this.flyOutContainer.style.top = siteHeaderBottom + 'px'
	}

	// handleNavClasses
	uspBarObserver = new IntersectionObserver(
		entries => {
			if (entries[0].isIntersecting === false) {
				this.body.classList.add('shrink-header-new')
				this.headerNew.classList.add('shrink-header-new')
				this.logoBoxParent.classList.add('shrink-header')
				// add exception, if screen is bigger than 575px
				if (window.innerWidth > 575) {
					this.portret.classList.add('fade-out-portret')
					this.logoBox.classList.add('move-logo-box-up')
				}
			} else {
				this.body.classList.remove('shrink-header-new')
				this.headerNew.classList.remove('shrink-header-new')
				this.logoBoxParent.classList.remove('shrink-header')
				if (window.innerWidth > 575) {
					this.portret.classList.remove('fade-out-portret')
					this.logoBox.classList.remove('move-logo-box-up')
				}
			}
		},
		{ threshold: [0.999] }
	)

	handleMainNavClick(event) {
		// Check if clicked outside mainNav or hamburgerButton, then close menu
		if (!this.mainNavUl.contains(event.target) && event.target.id !== 'back-button') {
			this.closeMenu()
		}

		// Check if clicked on homeButton, then close menu
		if (event.target === this.homeButton) {
			this.closeMenu()
		}

		// Check if clicked on menu item with sub-menu, then handle submenu click
		const menuItemWithSubMenu = event.target.closest('.menu-item-has-children > a')
		if (menuItemWithSubMenu) {
			this.handleSubMenuClick(event, menuItemWithSubMenu)
		}

		// Check if clicked on back button, then maybe go back in submenu
		if (event.target.id === 'back-button') {
			this.maybeSubMenuGoBack(event.target)
		}
	}

	// Add or remove event listeners or classes based on window width
	handleWindowResize() {
		if (window.innerWidth > 991) {
			if (document.body.classList.contains('fly-out-active')) {
				document.body.classList.remove('fly-out-active')
			}
			if (this.hamburgerButton.classList.contains('active')) {
				this.hamburgerButton.classList.remove('active')
			}
			if (this.mainNav.classList.contains('menu-active')) {
				this.mainNav.classList.remove('menu-active')
			}
		} else {
			// Stick flyout to header top
			this.stickFlyoutToHeaderTop()
		}
	}

	/**
	 * Add classes when the mobile menu button is clicked.
	 *
	 * @param e
	 */
	handleHamburgerButtonClick(e) {
		e.preventDefault()

		this.stickFlyoutToHeaderTop()

		document.body.classList.toggle('fly-out-active')
		this.hamburgerButton.classList.toggle('active')
		this.mainNav.classList.toggle('menu-active')
	}

	/**
	 * Check if, on mobile, clicked next to the menu and then close the menu.
	 *
	 * @param e
	 */
	maybeCloseMenu(e) {
		if (!this.mainNavUl.contains(e.target) && e.target.id !== 'back-button') {
			this.closeMenu()
		}
	}

	// Close the menu
	closeMenu() {
		document.body.classList.remove('fly-out-active')
		this.hamburgerButton.classList.remove('active')
		this.mainNav.classList.remove('menu-active')
	}

	// Handle submenu click
	handleSubMenuClick(event, menuItem) {
		if (!menuItem) {
			return
		}

		if (window.innerWidth >= 992) {
			return
		}

		event.preventDefault();

		const subMenu = menuItem.closest('.menu-item').querySelector('.sub-menu')

		this.maybeAddBackButton(menuItem, subMenu)

		subMenu.classList.add('active')
		this.mainNav.querySelector('#back-button').classList.remove('hidden')

		return false;
	}

	// Maybe add back button
	maybeAddBackButton(clickedItem, subMenu) {
		const firstSubMenuItem = subMenu.children[0]

		if (!firstSubMenuItem.classList.contains('sub-menu-back-button')) {
			const backButton = document.createElement('li')
			backButton.innerHTML = clickedItem.innerText
			backButton.classList.add('menu-item', 'sub-menu-back-button', 'hide-for-desktop')
			backButton.id = 'back-button'

			subMenu.insertBefore(backButton, firstSubMenuItem)
		}
	}

	// Maybe go back in submenu
	maybeSubMenuGoBack(clickedElement) {
		if (clickedElement && clickedElement.classList.contains('sub-menu-back-button')) {
			let subMenuLvl2 = document.querySelector('.nav-main__list .sub-menu.active .sub-menu.active')

			if (subMenuLvl2 && subMenuLvl2.classList.contains('active')) {
				subMenuLvl2.classList.remove('active')
			} else {
				let activeSubMenu = document.querySelector('.sub-menu.active')
				if (activeSubMenu) {
					activeSubMenu.classList.remove('active')
				}
				if (clickedElement.target) {
					clickedElement.target.classList.add('hidden')
				}
			}
		}
	}
}

// Initialize the menu handler
if (!document.body.classList.contains('page-template-page-landingpage') && !document.body.classList.contains('woocommerce-checkout')) {
	const MenuHandlerInstance = new MenuHandler()
}
